module.exports = "/images/ny-street-13.jpg";